// extracted by mini-css-extract-plugin
export default {"PollOptions":"PollOptions-module-a81b466b1928e698cdcf"};